import React, { useRef, useState, useEffect } from 'react'
//Helpers
import { getLocation } from '@helpers/helper.developments'
import { getPhotos, getQuality, getVideos } from '@helpers/helper.rendering'
import {
  getAge,
  getBluePrints,
  getFakeAddres,
  getOperations,
  getPrices,
  getTour,
  getTours,
  getType,
  makeTextAmenities,
  makeTextBathrooms,
  makeTextParking,
  makeTextSurfaces,
  makeTextTags,
} from '@helpers/helper.properties'
import Gallery from '@components/fsLightboxGallery'
import { Action, RealEstateDataPageComponentData, StateGallerySlice } from 'types'
import { useDispatch, useSelector } from 'react-redux'
import { setCurrentlyImage, setTogglerImages } from '@slices/galerySlice'
import MultiActionBar from '@components/multiactionBarDetail/1'
import useQueryProperty from '@hooks/useQueryProperty'
import { Col, Container, Row } from 'react-bootstrap'
import Slider from 'react-slick'
import { addFavorites, checkFavorite, getfavorites } from '@helpers/helper.favorites'
import toast from 'react-hot-toast'
import { updateFavorites } from '@slices/propertiesSlice'
import { useLocation } from '@reach/router'
import { useGetPushQuery } from '@apis/mediacore/push'
import {
  getActionByType,
  getCodeFromType,
  getCodes,
  getQueryEventTracker,
} from '@helpers/helper.actions'
import { informCustomEvent } from '@helpers/helper.analytics'
import { useCreateApplicationMutation as useSendTrackerEvent } from '@apis/mediacore/tracker'
const isBrowser = typeof window !== 'undefined'

const settingsSlick = {
  dots: false,
  infinite: true,
  speed: 500,
  fade: false,
  slidesToShow: 1,
  slidesToScroll: 1,
}

const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  fade: false,
  slidesToShow: 1,
  slidesToScroll: 1,
}

interface ExternalProps {
  propertyID: string
}

type CombinedProps = RealEstateDataPageComponentData & ExternalProps

const JumbotronProperty_1 = (props: CombinedProps) => {
  const { propertyID, multiActionBar: multiActionBarProp, global_data, height } = props
  const API_KEY = global_data.pageConfig.keys.tokko
  const { data: allPropertyData, isLoading } = useQueryProperty(propertyID, API_KEY)

  const {
    togglerVideos,
    togglerImages,
    togglerTours,
    togglerBlueprints,
    currentlyImage,
    currentlyBluePrint,
  } = useSelector((state: { gallery: StateGallerySlice }) => state.gallery)!

  const dispatch = useDispatch()

  const [sendTrackerEvent] = useSendTrackerEvent()

  const mediaBar = true
  const icons: string = global_data.pageConfig.design.icons
  const iconsStyle = icons === 'Solid' || icons === 'Light' ? `-${icons.toLowerCase()}` : ''
  const [positionSlider, setPositionSlider] = useState(1)
  const sliderRef = useRef<any>()

  const [listFavorites, setListFavorites] = useState(getfavorites('prop', 'template-site'))

  const isCompiler = process.env.GATSBY_IS_SITE_COMPILER === 'true'
  const { pathname } = useLocation()

  const currentPage = global_data.content.pages?.find(
    (page) =>
      (pathname.replaceAll('/', '') === page.path.replaceAll('/', '') && !isCompiler) ||
      (isCompiler &&
        pathname !== '/' &&
        pathname.replace(global_data.divisionPath!, '').replaceAll('/', '') ===
          page.path.replaceAll('/', '')) ||
      (pathname.includes('/emprendimiento/') && page.path === '/desarrollo_detalle') ||
      (pathname.includes('/propiedad/') && page.path === '/propiedad_detalle') ||
      (pathname.includes('/novedad/') && page.path === '/novedad_detalle'),
  )

  const { data: allPushData, isLoading: loading } = useGetPushQuery({
    page: currentPage?.id || '',
    data_id: propertyID || '',
  })

  const slider_action = getActionByType(
    allPushData,
    getCodeFromType('Slider de Imagenes Encabezado'),
  )
  const image_action = getActionByType(allPushData, getCodeFromType('Imagen Encabezado'))
  const video_action = getActionByType(allPushData, getCodeFromType('Video Encabezado'))

  const [open, setOpen] = useState(false)
  const [opens, setOpens] = useState(false)

  const clientHeight: number | undefined = isBrowser
    ? document?.getElementById('header')?.clientHeight
    : 0

  const UpdatePositionSlider = (e: any) => {
    setPositionSlider(e + 1)
    return dispatch(setCurrentlyImage(e + 1))
  }

  const toastCheck = (id: string, fake_address: string) => {
    if (!checkFavorite(id, 'prop', 'template-site'))
      return toast.success(fake_address + ' agregada a tus favoritos')
    else return toast.success(fake_address + ' eliminada de tus favoritos')
  }

  //PUSH MODULE
  const RenderPushSlider = () => {
    return (
      <div
        id="hero-main"
        style={{ height: `calc(100vh - ${clientHeight}px)` }}
        className="banner-main a inyected"
      >
        <Slider
          {...settings}
          ref={sliderRef}
        >
          {slider_action
            .at(0)
            ?.files.map(
              ({ file, url_destiny }: { file: string; url_destiny: string }, index: number) => (
                <div
                  key={index}
                  className="position-relative "
                >
                  <div
                    className={`${url_destiny && 'cursor-pointer'}`}
                    onClick={() => (url_destiny ? window?.open(url_destiny) : null)}
                  >
                    <div className="opacity"></div>
                    <img
                      src={file}
                      style={{ maxHeight: `calc(100vh - ${clientHeight}px)` }}
                      className="image-push"
                      alt=""
                    />
                  </div>
                </div>
              ),
            )}
        </Slider>
        <div className={'arrows-left onTop zindex-1'}>
          <div
            className="arrow"
            onClick={() => sliderRef.current.slickPrev()}
          >
            {' '}
            <i></i> <i></i>
          </div>
        </div>
        <div className={'arrows-right onTop zindex-1'}>
          <div
            className="arrow"
            onClick={() => sliderRef.current.slickNext()}
          >
            {' '}
            <i></i> <i></i>{' '}
          </div>
        </div>
      </div>
    )
  }

  const RenderPushImage = () => {
    return (
      <img
        style={{ maxHeight: `calc(100vh - ${clientHeight}px)`, height: '100%' }}
        className={
          'image-push w-100 object-fit-cover ' +
          (image_action.at(0)?.url_destiny && 'cursor-pointer')
        }
        onClick={() =>
          image_action.at(0)?.url_destiny ? window?.open(image_action.at(0)?.url_destiny) : null
        }
        src={image_action.at(0)?.files.at(0)?.file}
        alt=""
      />
    )
  }

  const RenderPushVideo = () => {
    return (
      <video
        className={'d-lg-block w-100 object-fit-cover '}
        style={{ maxHeight: `calc(100vh - ${clientHeight}px)`, height: '100%' }}
        loop
        autoPlay
        muted
      >
        <source
          src={
            isDesktop()
              ? video_action[0].files.find(
                  (video: { device: string }) => video.device === 'desktop',
                )?.file || video_action[0].files[0].file
              : video_action[0].files.find((video: { device: string }) => video.device === 'mobile')
                  ?.file || video_action[0].files[0].file
          }
          type="video/mp4"
        />
      </video>
    )
  }

  const isDesktop = () => (screen.width < 992 ? false : true)

  const goTo = () => {
    if (video_action[0].url_destiny) {
      if (isBrowser) {
        window.open(
          video_action[0].url_destiny + video_action[0].text_utm,
          '_blank',
          'noopener,noreferrer',
        )
      }
      informCustomEvent('PUSH_' + currentPage?.id + '_' + propertyID + '_' + video_action[0].id)
      sendTrackerEvent(
        getQueryEventTracker({
          page: currentPage!,
          action: video_action[0],
          type: 'PUSH',
          data_id: propertyID,
          url: location.href,
          extra_title: allPropertyData?.address,
        }),
      )
    }
  }

  const notpush =
    image_action.length === 0 && video_action.length === 0 && slider_action.length === 0

  useEffect(() => {
    if (allPropertyData) {
      if (video_action.length > 0) {
        informCustomEvent('SHOW_' + currentPage?.id + '_' + propertyID + '_' + video_action[0].id)
        sendTrackerEvent(
          getQueryEventTracker({
            page: currentPage!,
            action: video_action[0],
            type: 'SHOW',
            data_id: propertyID,
            url: location.href,
            extra_title: allPropertyData?.address,
          }),
        )
      }
      if (image_action.length > 0) {
        informCustomEvent('SHOW_' + currentPage?.id + '_' + propertyID + '_' + image_action[0].id)
        sendTrackerEvent(
          getQueryEventTracker({
            page: currentPage!,
            action: image_action[0],
            type: 'SHOW',
            data_id: propertyID,
            url: location.href,
            extra_title: allPropertyData?.address,
          }),
        )
      }
      if (slider_action.length > 0) {
        informCustomEvent('SHOW_' + currentPage?.id + '_' + propertyID + '_' + slider_action[0].id)
        sendTrackerEvent(
          getQueryEventTracker({
            page: currentPage!,
            action: slider_action[0],
            type: 'SHOW',
            data_id: propertyID,
            url: location.href,
            extra_title: allPropertyData?.address,
          }),
        )
      }
    }
  }, [allPropertyData])

  const validateGoTo = () => {
    if (video_action.length > 0) {
      goTo()
    } else if (image_action.length > 0) {
      goToImage(image_action[0])
    } else if (slider_action.length > 0) {
      goToImage(slider_action[0], 0)
    }
  }

  const goToImage = (action: Action, index?: number) => {
    if (index !== undefined && action?.files[index].url_destiny) {
      window?.open(action?.files[index].url_destiny)
    } else if (action.url_destiny) {
      window?.open(action?.url_destiny)
    }
    informCustomEvent('PUSH_' + currentPage?.id + '_' + propertyID + '_' + action.id)
    sendTrackerEvent(
      getQueryEventTracker({
        page: currentPage!,
        action: action,
        type: 'PUSH',
        data_id: propertyID,
        url: location.href,
        extra_title: allPropertyData?.address,
      }),
    )
  }

  return (
    <section
      // style={{ height: `calc(100vh - ${clientHeight}px)` }}
      className={'ficha-main hero-prop d ficha ' + (isLoading ? 'loader' : '')}
      onClick={() => validateGoTo()}
    >
      <Container fluid>
        {getVideos(allPropertyData?.videos).length > 0 ? (
          <Gallery
            index={1}
            sources={getVideos(allPropertyData?.videos)}
            slide={1}
            type={'video'}
            toggleEvent={togglerVideos}
            data={allPropertyData}
          />
        ) : null}
        {getPhotos(allPropertyData?.photos).length > 0 ? (
          <Gallery
            index={2}
            sources={getPhotos(allPropertyData?.photos)}
            slide={currentlyImage}
            type={'image'}
            toggleEvent={togglerImages}
            data={allPropertyData}
          />
        ) : null}
        {getTours(allPropertyData).length > 0 ? (
          <Gallery
            index={3}
            sources={getTours(allPropertyData)}
            slide={1}
            type={'tour'}
            toggleEvent={togglerTours}
            data={allPropertyData}
          />
        ) : null}
        {getBluePrints(allPropertyData).length > 0 ? (
          <Gallery
            index={4}
            sources={getBluePrints(allPropertyData)}
            slide={currentlyBluePrint}
            type={'blueprint'}
            toggleEvent={togglerBlueprints}
            data={allPropertyData}
          />
        ) : null}
        <Row className="d-flex">
          <Col
            xxl={12}
            lg={12}
            sm={12}
            // className={'px-0 prop-gallery position-relative ' + (isLoading ? 'skeleton' : '')}
            style={{ height: height?.desktop || '75vh' }}
            className={'px-0 prop-gallery position-relative '}
            id="prop-gallery"
          >
            {/* {isLoading && <Loading />} */}
            {notpush && (
              <span className="conPag">
                {positionSlider} / {getPhotos(allPropertyData?.photos).length}
              </span>
            )}
            <div className="badges">
              {getOperations(allPropertyData).map((operation) => (
                <p className="badge">{operation}</p>
              ))}
              <p className="badge">{getType(allPropertyData)}</p>
            </div>
            <div
              className={
                'grid-container ' +
                (getPhotos(allPropertyData?.photos)?.length == 2
                  ? 'duo'
                  : getPhotos(allPropertyData?.photos).length == 3
                  ? 'tri'
                  : getPhotos(allPropertyData?.photos)?.length == 4
                  ? 'quad'
                  : '') +
                (isLoading ? ' ' : '')
              }
              style={{ height: height?.desktop || '75vh' }}
            >
              {isLoading && (
                <div
                  style={{ height: height?.desktop || '75vh' }}
                  className="main-image skeleton object-cover object-center cursor-pointer"
                ></div>
              )}
              {isLoading && (
                <div className="sub-grid">
                  {[1, 2, 3, 4].map((element, index) => (
                    <div
                      key={index}
                      className={
                        'sub-image skeleton object-cover object-center cursor-pointer ' + element
                      }
                    ></div>
                  ))}
                </div>
              )}
              {getPhotos(allPropertyData?.photos).map((photo, index) => {
                if (index === 0) {
                  // Imagen principal
                  return (
                    <img
                      key={index}
                      onClick={() => {
                        dispatch(setCurrentlyImage(index + 1))
                        dispatch(setTogglerImages())
                      }}
                      src={getQuality(photo)}
                      className="main-image object-cover object-center cursor-pointer"
                    />
                  )
                } else if (index <= 4) {
                  // Subimágenes
                  return null
                }
                return null // Ignorar imágenes adicionales
              })}
              <div //Grilla Secundaria
                className="sub-grid"
                style={{ height: height?.desktop || '75bh' }}
              >
                {getPhotos(allPropertyData?.photos).map((photo, index) => {
                  if (index < 5 && index !== 0) {
                    return (
                      <img
                        onClick={() => {
                          dispatch(setCurrentlyImage(index + 1))
                          dispatch(setTogglerImages())
                        }}
                        src={getQuality(photo)}
                        className="sub-image object-cover object-center cursor-pointer"
                      />
                    )
                  }
                })}
              </div>
            </div>
            {image_action.length > 0 && <RenderPushImage />}
            {video_action.length > 0 && <RenderPushVideo />}
            {slider_action.length > 0 && <RenderPushSlider />}
            {!multiActionBarProp?.share && (
              <span
                onClick={() => dispatch(setTogglerImages())}
                className={'legend-fullscreen ' + (mediaBar && 'opacity-down-index')}
              >
                Abrir galería de imágenes
              </span>
            )}
            <div
              className={
                'content-global ' + (mediaBar ? 'opacity-down-index' : 'd-block d-lg-block ')
              }
            ></div>
            {multiActionBarProp && (
              <MultiActionBar
                itemsBar={multiActionBarProp}
                data={allPropertyData}
                skeleton={isLoading}
                global_data={global_data}
                vertical={false}
                propertyID={propertyID}
              />
            )}
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default JumbotronProperty_1
